export const codeArr = [
    {
      code: `int result = 5 + 3 * 2;`
    },
    {
      code: `int x = 10;
int y = 5;
int z = x / (y - 2);`
    },
  ];
  